// window.theme = window.theme || {};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
// Removed unused Shopify helper functions and CountryProvinceSelector.

class App {
  constructor() {
    this.calcHeaderAnnouncementBarHeight();
    this.calcViewport();
    this.eventListeners();
    this.addThemeInfo();
    this.setFirstSession();
    this.observeRTLChanges();
  }

  addThemeInfo() {
    if (window.theme === undefined) return;
    document.documentElement.setAttribute(
      "data-theme-name",
      window.theme.info.name
    );
    document.documentElement.setAttribute(
      "data-theme-version",
      window.theme.info.version
    );
  }

  isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  isFirstSession() {
    return sessionStorage.getItem("firstSession") === null;
  }

  isRTL() {
    return document.documentElement.dir === "rtl";
  }

  setFirstSession() {
    if (this.isFirstSession()) {
      sessionStorage.setItem("firstSession", true);
      document.documentElement.setAttribute("data-first-session", true);
    } else {
      document.documentElement.setAttribute("data-first-session", false);
    }
  }

  calcViewport() {
    let vh = window.innerHeight * 0.01;
    let vw = window.innerWidth * 0.01;

    document.documentElement.style.setProperty("--vh", `${vh}px`);
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  }

  calcHeaderAnnouncementBarHeight() {
    let header = document.querySelector(".shopify-section-header");
    let announcementbar = document.querySelector(
      ".shopify-section-announcement-bar"
    );

    let height = 0;
    let headerHeight = header ? header.getBoundingClientRect().height : 0;
    let announcementbarHeight = announcementbar
      ? announcementbar.getBoundingClientRect().height
      : 0;

    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      `${announcementbarHeight}px`
    );

    height = headerHeight + announcementbarHeight;
    document.documentElement.style.setProperty(
      "--top-content-height",
      `${height}px`
    );

    // return height;
  }

  onResize() {
    this.calcViewport();
    this.calcHeaderAnnouncementBarHeight();
  }

  observeRTLChanges() {
    const targetNode = document.documentElement; // Typically the <html> element
    const config = {
      attributes: true,
    };

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "dir"
        ) {
          this.isRTL = document.documentElement.getAttribute("dir") === "rtl";
          this.emitRTLChange(); // Emit an event when direction changes
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  emitRTLChange() {
    const event = new CustomEvent("rtlChange", {
      detail: {
        isRTL: this.isRTL,
      },
    });
    window.dispatchEvent(event);
  }

  eventListeners() {
    window.addEventListener("resize", this.onResize.bind(this));
  }
}

window.app = new App();
// Removed unused AnnouncementBar custom element.

// Removed unused DropdownLink custom element.

class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.hamburgerIcon = this.querySelector("#MenuDrawer-HamburgerIcon");
    this.drawer = this.querySelector("#MenuDrawer");
    this.drawerInner = this.querySelector(".menu-drawer__wrapper");

    this.animate = gsap.timeline({
      paused: true,
      reversed: true,
    });

    // Control when scroll-to-close is allowed (avoid closing during open animation)
    this.scrollCloseEnabled = true;

    this.animation();
    this.eventListeners();
  }

  toggle() {
    if (this.isDrawerOpen) {
      this.hideDrawer();
    } else {
      this.showDrawer();
    }
    const willPlay = this.animate.reversed();
    willPlay ? this.animate.play() : this.animate.reverse();
  }

  animation() {
    this.animate.fromTo(
      this.drawer,
      {
        display: "none",
        autoAlpha: 0,
      },
      {
        display: "block",
        autoAlpha: 1,
        duration: 0.3,
      }
    );
    this.animate.eventCallback("onComplete", () => {
      this.scrollCloseEnabled = true;
      const containerToTrapFocus = this.drawer;
      const focusables = getFocusableElements(containerToTrapFocus);
      const focusElement = focusables[0] || containerToTrapFocus;
      trapFocus(containerToTrapFocus, focusElement);
    });
  }

  showDrawer() {
    this.isDrawerOpen = true;
    // Temporarily disable scroll-close until open animation completes
    this.scrollCloseEnabled = false;

    if (this.hamburgerIcon) this.hamburgerIcon.style.display = "none";
    if (this.hamburgerIcon)
      this.hamburgerIcon.setAttribute("aria-expanded", "true");

    this.addCloseListeners();
  }

  hideDrawer() {
    if (this.hamburgerIcon) this.hamburgerIcon.style.display = "block";
    if (this.hamburgerIcon)
      this.hamburgerIcon.setAttribute("aria-expanded", "false");

    removeTrapFocus(this.hamburgerIcon);

    this.isDrawerOpen = false;

    this.removeCloseListeners();
  }

  eventListeners() {
    this.hamburgerIcon.addEventListener("click", this.toggle.bind(this));

    document.addEventListener("keydown", (e) => {
      if (e.keyCode === 27) {
        this.hideDrawer();
        this.animate.reverse();
      }
    });
  }

  addCloseListeners() {
    this.onDocumentClickBound = this.onDocumentClick?.bind(this) || null;
    this.onOverlayClickBound = this.onOverlayClick?.bind(this) || null;
    this.onScrollBound = this.onScroll?.bind(this) || null;

    if (this.onDocumentClickBound)
      document.addEventListener("click", this.onDocumentClickBound);
    if (this.drawer && this.onOverlayClickBound)
      this.drawer.addEventListener("click", this.onOverlayClickBound);
    if (this.onScrollBound) {
      window.addEventListener("scroll", this.onScrollBound, { passive: true });
      window.addEventListener("wheel", this.onScrollBound, { passive: true });
      window.addEventListener("touchmove", this.onScrollBound, {
        passive: true,
      });
    }
  }

  removeCloseListeners() {
    if (this.onDocumentClickBound)
      document.removeEventListener("click", this.onDocumentClickBound);
    if (this.drawer && this.onOverlayClickBound)
      this.drawer.removeEventListener("click", this.onOverlayClickBound);
    if (this.onScrollBound) {
      window.removeEventListener("scroll", this.onScrollBound);
      window.removeEventListener("wheel", this.onScrollBound);
      window.removeEventListener("touchmove", this.onScrollBound);
    }
  }

  onDocumentClick(event) {
    if (!this.isDrawerOpen) return;
    const target = event.target;
    const clickedInsideDrawer = this.drawer.contains(target);
    const clickedHamburger =
      this.hamburgerIcon &&
      (this.hamburgerIcon === target || this.hamburgerIcon.contains(target));

    if (!clickedInsideDrawer && !clickedHamburger) {
      this.hideDrawer();
      this.animate.reverse();
    }
  }

  onOverlayClick(event) {
    if (!this.isDrawerOpen) return;
    // If the click is outside the pill content (drawerInner), close the drawer
    const clickedInsideContent =
      this.drawerInner && this.drawerInner.contains(event.target);
    if (!clickedInsideContent) {
      this.hideDrawer();
      this.animate.reverse();
    }
  }

  onScroll() {
    if (!this.isDrawerOpen || !this.scrollCloseEnabled) return;
    this.hideDrawer();
    this.animate.reverse();
  }
}

customElements.define("header-drawer", HeaderDrawer);


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");

    this.changeEvent = new Event("change", { bubbles: true });
    this.quantityUpdateEvent = new CustomEvent(PUB_SUB_EVENTS.quantityUpdate, {
      bubbles: true,
      detail: { value: 0 },
    });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.updateQuantity();
  }

  updateQuantity() {
    const value = parseInt(this.input.value);
    this.validateQtyRules(value);

    this.input.dispatchEvent(this.changeEvent);
    this.quantityUpdateEvent.detail.value = value;
    this.dispatchEvent(this.quantityUpdateEvent);
  }

  validateQtyRules(value) {
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class BackgroundVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.toggleSoundButton = this.querySelector(".toggle-sound");

    this.soundOnLabel = this.dataset.soundOnLabel;
    this.soundOffLabel = this.dataset.soundOffLabel;

    this.eventListeners();
  }

  isInViewport() {
    const rect = this.getBoundingClientRect();
    return (
      (rect.top >= 0 && rect.top <= window.innerHeight) ||
      (rect.bottom >= 0 && rect.bottom <= window.innerHeight)
    );
  }

  onToggleSound() {
    this.video.muted = !this.video.muted;
    this.toggleSoundButton.innerHTML = this.video.muted
      ? this.soundOnLabel
      : this.soundOffLabel;
    this.toggleSoundButton.setAttribute("aria-pressed", !this.video.muted);
  }

  onScroll() {
    if (this.isInViewport()) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  eventListeners() {
    this.toggleSoundButton
      ? this.toggleSoundButton.addEventListener(
          "click",
          this.onToggleSound.bind(this)
        )
      : null;
    this.toggleSoundButton
      ? this.toggleSoundButton.addEventListener("keydown", (e) => {
          if (e.keyCode === 13) {
            this.onToggleSound();
          }
        })
      : null;

    window.addEventListener("scroll", debounce(this.onScroll.bind(this), 100));
  }
}
customElements.define("background-video", BackgroundVideo);

class passwordVisibility extends HTMLElement {
  constructor() {
    super();

    this.passwordInput = this.querySelector("input");
    this.togglePasswordButton = this.querySelector("button");
    this.togglePasswordButtonSpans = this.querySelectorAll("button > span");
    this.togglePasswordButton.addEventListener(
      "click",
      this.togglePasswordVisibility.bind(this)
    );
  }

  togglePasswordVisibility(e) {
    e.preventDefault();
    if (this.passwordInput.type === "password") {
      this.passwordInput.type = "text";
      this.togglePasswordButton.setAttribute("aria-pressed", "true");
      this.togglePasswordButtonSpans[0].classList.add("visually-hidden");
      this.togglePasswordButtonSpans[1].classList.remove("visually-hidden");
    } else {
      this.passwordInput.type = "password";
      this.togglePasswordButton.setAttribute("aria-pressed", "false");
      this.togglePasswordButtonSpans[0].classList.remove("visually-hidden");
      this.togglePasswordButtonSpans[1].classList.add("visually-hidden");
    }
  }
}

customElements.define("password-visibility", passwordVisibility);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateVariantId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    if (!this.currentVariant) return;
    this.dispatchEvent(
      new CustomEvent(PUB_SUB_EVENTS.variantChange, {
        bubbles: true,
        detail: {
          currentVariant: this.currentVariant,
          sectionId: this.currentVariant.id,
        },
      })
    );
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked
          )?.value;
        }
      }
    );
  }

  updateVariantId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const quickAddModal = this.closest("quick-add-modal");
    if (!quickAddModal) {
      const media = document.getElementById(
        `ProductMedia-${this.dataset.section}`
      );
      const currentMedia = media.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      media.slider.selectCell(currentMedia);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#Product-Form-${this.dataset.section}, #Product-Form-Installment-${this.dataset.section}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `Price-${this.dataset.section}`
        );
        const source = html.getElementById(`Price-${this.dataset.section}`);

        const stickyPriceDestination = document.getElementById(
          `StickyPrice-${this.dataset.section}`
        );
        const stickyPriceSource = html.getElementById(
          `StickyPrice-${this.dataset.section}`
        );

        const stickyAddToCartDestination = document.getElementById(
          `StickyAddToCart-${this.dataset.section}`
        );
        const stickyAddToCartSource = html.getElementById(
          `StickyAddToCart-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stickyPriceSource && stickyPriceDestination)
          stickyPriceDestination.innerHTML = stickyPriceSource.innerHTML;
        if (stickyAddToCartSource && stickyAddToCartDestination)
          stickyAddToCartDestination.innerHTML =
            stickyAddToCartSource.innerHTML;

        const price = document.getElementById(`Price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(
      `Product-Form-${this.dataset.section}`
    );
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const isPreorder = addButton.dataset.isPreorder === "true";

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = isPreorder
        ? window.variantStrings.preOrder
        : window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const button = document.getElementById(
      `Product-Form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`Price-${this.dataset.section}`);

    if (!addButton) return;

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      pickUpAvailability.removeAttribute("available");
    } else {
      pickUpAvailability.innerHTML = "";
    }
  }
}
customElements.define("variant-selects", VariantSelects);

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest(".product__container");
    this.buyButtons = this.parent.querySelector(".product__buy-buttons");
    this.isInViewClass = "product__sticky-bar--in-view";

    this.observeIntersection();
    window.onscroll = this.onScrollHandler.bind(this);
  }

  addInViewClass() {
    this.classList.add(this.isInViewClass);
    this.setAttribute("aria-hidden", "false");
    setTimeout(() => {
      this.removeAttribute("hidden");
    }, 100);
  }

  removeInViewClass() {
    this.classList.remove(this.isInViewClass);
    this.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      this.setAttribute("hidden", "");
    }, 100);
  }

  onScrollHandler() {
    this.footer = document.querySelector(".shopify-section-footer");
    this.footerRect = this.footer.getBoundingClientRect();

    this.position = window.pageYOffset + window.innerHeight;

    if (this.position > this.footer.offsetTop) {
      this.removeInViewClass();
    } else {
      if (!this.isInView) this.addInViewClass();
    }
  }

  observeIntersection() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.removeInViewClass();
          this.isInView = true;
        } else {
          this.addInViewClass();
          this.isInView = false;
        }
      });
    });

    this.observer.observe(this.parent);
  }
}

customElements.define("product-sticky-bar", ProductStickyBar);

// Removed unused CamaSlider custom element.

class ProductMedia extends HTMLElement {
  connectedCallback() {
    this.element = this.querySelector("[data-slider]");
    this.thumbnails = this.querySelector("[data-product-thumbnails]");
    this.elementNotDraggable = this.querySelector("[data-draggable=false]");
    this.mount(this.element, this.thumbnails);

    window.addEventListener("resize", () => {
      this.resizeSliders();
    });
  }

  resizeSliders() {
    setTimeout(() => {
      this.slider.resize();
      this.sliderNav.resize();
    }, 1);
  }

  getCurrentMediaType() {
    const selectedCell = this.slider.selectedCell;
    const mediaType = selectedCell.element.dataset.mediaType;
    this.element.dataset.currentMediaType = mediaType;
  }

  mount(node, nodeThumbnails, options = {}) {
    window.pauseAllMedia();

    this.slider = new Flickity(node, {
      draggable: false,
      cellAlign: "left",
      contain: true,
      accessibility: true,
      freeScroll: false,
      adaptiveHeight: true,
      // wrapAround: true,
      // watchCSS: true,
      prevNextButtons: true,
      pageDots: false,
      ...options,
    });

    this.sliderNav = new Flickity(nodeThumbnails, {
      asNavFor: node,
      cellAlign: "center",
      accessibility: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });

    this.getCurrentMediaType();

    this.slider.on("select", () => {
      this.getCurrentMediaType();
    });

    this.slider.on("change", () => {
      window.pauseAllMedia();
    });

    if (!this.thumbnails) return;

    const thumbnailsButtons = this.thumbnails.querySelectorAll(
      ".product-thumbnails__item button"
    );

    thumbnailsButtons.forEach((button, index) => {
      button.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          this.slider.select(index);
        }
      });
    });
  }

  unMount() {
    this.slider.destroy();
    this.sliderNav.destroy();
  }

  onLoad() {
    this.unMount();
    this.mount(this.element, this.thumbnails);
  }

  onUnload() {
    this.unMount();
  }
}

customElements.define("product-media", ProductMedia);
